import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_467 implements Validator {

    public static id = 'CTRL_467';
    private message = 'error.ctr_467';


    public LOG: LogService = new LogService(CTRL_467);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_467.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const servicesNameWithStepId = map.get(ctrl.value.rgCtrls.services);
                const prestationreserveeNameWithStepId = map.get(ctrl.value.rgCtrls.prestationreservee);
                const servicesCtrl = form.controls[servicesNameWithStepId];
                const prestationreserveeCtrl = form.controls[prestationreserveeNameWithStepId];
                if (prestationreserveeCtrl.value !== "" && servicesCtrl.value !== "services") {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}